import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import { Button, CircularProgress, IconButton } from "@mui/material";
import AppContext from "../../container/context";
import ActionTable from "../../components/table/ActionTable";
import { formatDateTime } from "../../helpers/helpers";

export default function Grupo(props) {
  const history = props.history;
  const [grupoId] = useState(Number(props.match.params.id));
  const [carregando, setCarregando] = useState(false);
  const [dados, setDados] = useState({ nome: "", ativo: false });
  const [buscaEscola, setBuscaEscola] = useState({ nomeFantasia: "" });
  const { notification } = useContext(AppContext);
  const [membros, setMembros] = useState([]);
  const [escolasLocalizadas, setEscolasLocalizadas] = useState([]);
  const [escolaSelecionada, setEscolaSelecionada] = useState(null);

  useEffect(() => {
    if (grupoId > 0) {
      carregar();
      carregarMembros();
    }
  }, []);

  const carregar = () => {
    setCarregando(true);

    api
      .get("gruposPreco/carregar", { id: grupoId })
      .then((res) => {

        res.validade = res.validade ? formatDateTime(res.validade, "Y-M-D") : '';
        res.valor = (res.valorCentavos / 100).toFixed(2);

        setDados(res);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível carregar grupo");
        setCarregando(false);
      });
  };

  const carregarMembros = () => {
    setCarregando(true);

    api
      .get("gruposPreco/listarEscolas", { grupoPrecoId: grupoId })
      .then((res) => {
        res.forEach(r => {
          r.produtoBilingue = r.escolaGrupoPrecoBilingue ? (
            <div>
              Membro 
              <IconButton
                key={1}
                title={'Remover'}
                style={{ color: 'red' }}
                onClick={() => removerEscola(r.escolaId, 'BILINGUE')}
              >
                <i className="zmdi zmdi-smartphone-erase"></i>
              </IconButton> 
            </div> 
          ) : (
            <div>
              - 
              <IconButton
                key={1}
                title={'Adicionar'}
                style={{ color: 'blue' }}
                onClick={() => inserirEscola(r.escolaId, 'BILINGUE')}
              >
                <i className="zmdi zmdi-smartphone-download"></i>
              </IconButton> 
            </div> 
          );
          r.produtoUDT = r.escolaGrupoPrecoUdt ? (
            <div>
              Membro 
              <IconButton
                key={1}
                title={'Remover'}
                style={{ color: 'red' }}
                onClick={() => removerEscola(r.escolaId, 'UDT')}
              >
                <i className="zmdi zmdi-smartphone-erase"></i>
              </IconButton> 
            </div> 
          ) : (
            <div>
              - 
              <IconButton
                key={1}
                title={'Adicionar'}
                style={{ color: 'blue' }}
                onClick={() => inserirEscola(r.escolaId, 'UDT')}
              >
                <i className="zmdi zmdi-smartphone-download"></i>
              </IconButton> 
            </div> 
          );
        });

        setMembros(res);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível listar as escolas membros do grupo");
        setCarregando(false);
      });
  };

  const salvar = (params) => {
    let dadosParams = dados;
    dadosParams.nome = params.nome;
    dadosParams.valorCentavos = params.valor*100;
    dadosParams.validade = params.validade;

    if (grupoId > 0) dadosParams.id = grupoId;
    setDados(dadosParams);

    if (grupoId === 0) {
      api
        .put("gruposPreco/inserir", dadosParams)
        .then((res) => {
          notification("success", "Grupo inserido!");

          history.goBack()
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            case 2:
              return notification("error", "Valor inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    } else {
      api
        .post("gruposPreco/editar", dadosParams)
        .then((res) => {
          notification("success", "Grupo editado!");
          setDados({ nome: "", ativo: false });
          history.goBack();
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    }
  };

  const fDados = {
    title: "Grupo de preço",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 6,
        value: dados.nome,
      },
      valor: {
        label: "Valor (R$)",
        type: "number",
        space: 3,
        value: dados.valor,
      },
      validade: {
        label: "Validade",
        type: "date",
        value: dados.validade,
        space: 3,
      },
    },
    submit: {
      label: "Salvar",
      action: salvar,
    },
    history,
    close: true,
  };

  const tEscolas = {
    title: "Escolas",
    key: "escolaId",
    newItemAction: () => setEscolaSelecionada({}),
    columns: [
      {
        name: "escolaNomeFantasia",
        label: "Nome fantasia",
        type: "text",
      },
      {
        name: "produtoBilingue",
        label: "Bilíngue",
      },
      {
        name: "produtoUDT",
        label: "Uni dune te",
      },
    ],
    array: membros,
  };

  const buscar = (params) => {
    setBuscaEscola(params);
    
    setCarregando(true);

    api
      .get("escolas/listar", params)
      .then((res) => {
        res.forEach(r => {
          r.gerenciamentoBiligue = (
            <Button
              variant="contained"
              color={r.escolaGrupoPrecoBilingue ? "danger" : "info"}
              style={{color: 'white'}}
              onClick={() => inserirEscola(r.id, 'BILINGUE')}
            >
              {r.escolaGrupoPrecoBilingue ? 'Remover para bilíngue' : 'Adicionar para bilíngue'}
            </Button>
          );
          r.gerenciamentoUDT = (
            <Button
              variant="contained"
              color={r.escolaGrupoPrecoUdt ? "danger" : "info"}
              style={{color: 'white'}}
              onClick={() => inserirEscola(r.id, 'UDT')}
            >
              {r.escolaGrupoPrecoUdt ? "Remover para UDT" : "Adicionar para UDT"}              
            </Button>
          );
        });        

        setEscolasLocalizadas(res);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível listar profissionais");
        setCarregando(false);
      });
  };

  const fBuscaEscola = {
    title: "Localizar escola",
    form: {
      nome: {
        label: "Nome fantasia",
        type: "text",
        value: buscaEscola.nome
      },
    },
    submit: {
      label: "Buscar",
      action: buscar,
    },
    close: {
      label: "Fechar",
      action: () => {
        setBuscaEscola({});
        setEscolaSelecionada(null);
      },
    },
  };

  const inserirEscola = (escolaId, produto) => {
    api
      .post("gruposPreco/inserirEscola", { escolaId, produto, grupoPrecoId: grupoId })
      .then((res) => {
        notification("success", "Escola adicionada!");
        setEscolaSelecionada(null);
        setEscolasLocalizadas([]);
        carregarMembros();
      })
      .catch((err) => {
        notification("error", "Não foi possível inserir a escola");
        setCarregando(false);
      });
  };

  const removerEscola = (escolaId, produto) => {
    api
      .delete("gruposPreco/removerEscola", { escolaId, produto, grupoPrecoId: grupoId })
      .then((res) => {
        notification("warning", "Escola removida");
        setEscolaSelecionada(null);
        setEscolasLocalizadas([]);
        carregarMembros();
      })
      .catch((err) => {
        notification("error", "Não foi possível remover a escola");
        setCarregando(false);
      });
  };

  const tBusca = {
    title: "Escolas localizadas",
    array: escolasLocalizadas,
    key: "usuarioId",
    columns: [
      {
        name: "nomeFantasia",
        label: "Nome fantasia",
      },
      {
        name: "gerenciamentoBiligue",
        label: "",
      },
      {
        name: "gerenciamentoUDT",
        label: "",
      }
    ]
  };

  return(
    <div>
      {escolaSelecionada ? (
        <>
          <Form formData={fBuscaEscola} />
          {carregando ? (
            <CircularProgress />
          ) : (
            <ActionTable structure={tBusca} />
          )}
        </>
      ) : (
        <>
          {carregando ? <CircularProgress /> : <Form formData={fDados} />}
          {grupoId > 0 && (
            <>
              {carregando ? (
                <CircularProgress />
              ) : (
                <ActionTable structure={tEscolas} />
              )}
            </>
          )}
        </>
      )}
    </div>
  )

  return (
    <div>
      {!escolaSelecionada ? (
        <>
          {carregando ? <CircularProgress /> : <Form formData={fDados} />}
          {grupoId > 0 && (
            <>
              {carregando ? (
                <CircularProgress />
              ) : (
                <ActionTable structure={tEscolas} />
              )}
            </>
          )}
        </>
      ) : (
        <>
          <Form formData={fBuscaEscola} />
          {carregando ? (
            <CircularProgress />
          ) : (
            <ActionTable structure={tBusca} />
          )}
        </>
      )}
    </div>
  );
}
